import { buildResizableImageUrl, DEFAULT_IMAGE } from '@autone/utils';
import { type HTMLProps, useState } from 'react';

type ImageProps = Omit<HTMLProps<HTMLImageElement>, 'size'> & {
  size?: 'small' | 'medium' | 'large' | 'original';
};

export const Image = ({ size = 'medium', ...props }: ImageProps) => {
  const [error, setError] = useState(false);

  if (error || !props.src) {
    return (
      <img
        alt={props.alt}
        {...props}
        src={buildResizableImageUrl(DEFAULT_IMAGE, size)}
      />
    );
  }

  return (
    <img
      alt={props.alt}
      onError={() => setError(true)}
      {...props}
      src={buildResizableImageUrl(props.src, size)}
    />
  );
};
